<template>
  <div
    ref="cell"
    class="grid-view__cell active"
    :class="{
      editing: editing,
      invalid: editing && !valid,
    }"
    @contextmenu="stopContextIfEditing($event)"
  >
    <div v-show="!editing" class="grid-field-colour">
      <div
        v-if="isValidHexColour(value)"
        class="grid-field-colour__swatch"
        :style="{ backgroundColor: value }"
      ></div>
      <div class="grid-field-colour__text">
        <SearchHighlightedText :text="value" :search-term="searchTerm" />
      </div>
    </div>
    <template v-if="editing">
      <!-- Native colour input drives the picker UI; the paired text input lets the
           user type/paste a hex value directly since <input type="color"> can't. -->
      <input
        v-if="isValidHexColour(copy)"
        type="color"
        class="grid-field-colour__picker"
        :value="copy"
        @input="copy = $event.target.value"
      />
      <input
        ref="input"
        v-model="copy"
        type="text"
        class="grid-field-text__input grid-field-colour__input"
      />
      <div v-show="!valid" class="grid-view__cell-error align-right">
        {{ error }}
      </div>
    </template>
  </div>
</template>

<script>
import gridField from '@baserow/modules/database/mixins/gridField'
import gridFieldInput from '@baserow/modules/database/mixins/gridFieldInput'
import { isValidHexColour } from '@baserow/modules/core/utils/string'
import SearchHighlightedText from '@baserow/modules/database/components/view/grid/fields/SearchHighlightedText'

export default {
  components: { SearchHighlightedText },
  mixins: [gridField, gridFieldInput],
  methods: {
    isValidHexColour,
    afterEdit() {
      this.$nextTick(() => {
        this.$refs.input.focus()
        this.$refs.input.selectionStart = this.$refs.input.selectionEnd = 100000
      })
    },
  },
}
</script>
